import { pageSelectorGenerator } from '@test/pageSelectors';

export const PaperCheckoutConfirmAndNotifySelectors = pageSelectorGenerator('PaperCheckoutConfirmAndNotify', ['ContainerElement', 'ConfirmButton', 'CancelButton']);
